import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { getClassName } from '../utils/get-class-name';
var Container = styled.div.withConfig({
  displayName: "InlineFieldGroup__Container"
})(["display:flex;flex-direction:row;align-items:", ";justify-content:", ";width:100%;> *{margin-right:.5rem;&:last-child{margin-right:0;}&:first-child{margin-left:0;}}"], function (props) {
  return props.isVerticallyCentered ? 'center' : 'flex-start';
}, function (props) {
  return props.isHorizontallyCentered ? 'center' : 'flex-start';
});

var InlineFieldGroup = function InlineFieldGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$isHorizontallyCe = _ref.isHorizontallyCentered,
      isHorizontallyCentered = _ref$isHorizontallyCe === void 0 ? false : _ref$isHorizontallyCe,
      _ref$isVerticallyCent = _ref.isVerticallyCentered,
      isVerticallyCentered = _ref$isVerticallyCent === void 0 ? true : _ref$isVerticallyCent;
  return _jsx(Container, {
    className: getClassName(className, null, 'inline-field-group-container'),
    isHorizontallyCentered: isHorizontallyCentered,
    isVerticallyCentered: isVerticallyCentered,
    children: children
  });
};

var InlineFieldGroupTest = {
  Container: Container
};
export { InlineFieldGroup, InlineFieldGroupTest };
export default InlineFieldGroup;